import React from 'react';
import Isvg from 'react-inlinesvg';
import myTimeLogoSrc from 'static/img/Integrators/mytime-logo.png';
import { bem } from 'helpers/class-name';
import { PFE_ICONS } from 'constants/icons';
import { Button } from 'components/Form';
import { Form, Input } from 'components/HookForm';
import Message from 'components/Message';
import PropTypes from 'prop-types';
import { messages } from './Connect.messages';

import './Connect.scss';

const { element } = bem('connect');

const ConnectPage = ({ handleSubmit }) => {
  return (
    <div className={element('wrapper')}>
      <div className="icons">
        <Isvg className={element('logo')} src={PFE_ICONS.logotype} />
        <div className="vertical-divider" />
        <img className={element('spots-illustration')} src={myTimeLogoSrc} alt="" />
      </div>
      <Form onSubmit={handleSubmit}>
        <div className="header">
          <Message message={messages.title} as="h1" className={element('title')} />
          <Message message={messages.instructions} />
        </div>
        <Input
          name="partnerId"
          type="text"
          placeholder={messages.companyId}
          required
          className={element('input', 'mb-r')}
          autoFocus
          autoComplete="new-password"
        />
        <Input
          name="apiKey"
          type="password"
          placeholder={messages.apiKey}
          required
          className={element('input', 'mb-r')}
          autoComplete="new-password"
        />
        <Button type={Button.TYPES.SUBMIT} className={element('submit')}>
          <Message message={messages.connect} />
        </Button>
      </Form>
      <Message message={messages.followup} className={element('followup')} />
    </div>
  );
};

ConnectPage.propTypes = {
  handleSubmit: PropTypes.func,
};

export default ConnectPage;
